interface Props {
  className?: string;
  color?: string;
}

export function CardSpinner({
  className = "h-8 w-8",
  color = "#d1d5db",
}: Props) {
  return (
    <>
      <style>{`
        @keyframes cs-fan {
          0%, 12%  { transform: rotate(0deg); }
          42%, 62% { transform: rotate(var(--cs-angle)); }
          88%, 100% { transform: rotate(0deg); }
        }
        .cs-card {
          transform-box: fill-box;
          transform-origin: 50% 100%;
          animation: cs-fan 2.2s cubic-bezier(0.45, 0.05, 0.2, 1) infinite;
        }
        .cs-card-1 { --cs-angle: -24deg; animation-delay: 0s; }
        .cs-card-2 { --cs-angle:   0deg; animation-delay: 0.07s; }
        .cs-card-3 { --cs-angle:  24deg; animation-delay: 0.14s; }
      `}</style>
      <svg
        className={className}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Chargement"
      >
        <g transform="translate(50 74)">
          <rect
            className="cs-card cs-card-1"
            x="-14"
            y="-46"
            width="28"
            height="46"
            rx="3"
            fill={color}
            opacity="0.35"
          />
          <rect
            className="cs-card cs-card-2"
            x="-14"
            y="-46"
            width="28"
            height="46"
            rx="3"
            fill={color}
            opacity="0.65"
          />
          <rect
            className="cs-card cs-card-3"
            x="-14"
            y="-46"
            width="28"
            height="46"
            rx="3"
            fill={color}
          />
        </g>
      </svg>
    </>
  );
}
